import MoveUpAnimation from '../components/MoveUpAnimation'
import PageBase from '../components/PageBase'
import { useAppT } from '../localization/config'

export default function ExercisePage() {
  const t = useAppT()

  return (
    <PageBase title={t.exercise_title} subtitle={t.exercise_subtitle} scroolToTop>
      <MoveUpAnimation>
        <div className="flex flex-col gap-4 mt-4">
          <img src="/assets/images/lapidarium_1.jpg" alt="Lapidárium" className="w-full rounded-lg" />
          <img src="/assets/images/lapidarium_2.jpg" alt="Lapidárium" className="w-full rounded-lg" />
        </div>

        <h3 className="mt-8">🏰 {t.exercise_where_title}</h3>
        <p>{t.exercise_where_text}</p>

        <h3 className="mt-4">🧘‍♀️ {t.exercise_what_title}</h3>
        <ul className="list-[circle] mt-4">
          <li>{t.exercise_what_item_1}</li>
          <li>{t.exercise_what_item_2}</li>
          <li>{t.exercise_what_item_3}</li>
        </ul>

        <h3 className="mt-4">👗 {t.exercise_bring_title}</h3>
        <p>{t.exercise_bring_text}</p>

        <p className="mt-4">{t.exercise_text_3}</p>

        <h3 className="mt-8">🔥 {t.exercise_kundalini_title}</h3>
        <p className="mt-2 italic">{t.exercise_kundalini_desc}</p>
        <p className="mt-4">{t.exercise_kundalini_question}</p>
        <p className="mt-2">{t.exercise_kundalini_answer}</p>
        <p className="mt-4 font-semibold">{t.exercise_kundalini_expect_title}</p>
        <p className="mt-1">{t.exercise_kundalini_expect_text}</p>
        <p className="mt-4">
          {t.exercise_kundalini_link_text}{' '}
          <a href="https://www.tancujmedituj.cz/" target="_blank" rel="noopener noreferrer" className="underline">
            www.tancujmedituj.cz
          </a>
        </p>
      </MoveUpAnimation>

      <MoveUpAnimation>
        <img src="/assets/images/exercise.webp" alt="Exercise" className="w-full rounded-lg mt-8" />
      </MoveUpAnimation>
    </PageBase>
  )
}
